<template>
    <v-dialog
        v-model="showDialog"
        width="700"
    >
        <v-data-table
            ref="dataTabletest"
            :items="selectedSortByName"
            :headers="headers"
            dense
            :search="search.value"
            :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000, -1],
                'items-per-page-text': ''
            }"
            class="memberQualificationSelectedTbl"
            @pagination="onPaginationChange"
        >
            <template #top>
                <v-card-title>
                    Selected ({{ selected && selected.length }})
                    <v-spacer />
                    <div
                        class="search-wrapper"
                        @mouseenter="hovered = true"
                        @mouseleave="hovered = false"
                    >
                        <v-icon
                            class="search-icon"
                            color="teal darken-1"
                            @click="search.value = search.query"
                        >
                            {{ mdiMagnify }}
                        </v-icon>
                        <transition name="expand">
                            <v-text-field
                                v-if="hovered || search.value !== null"
                                ref="searchInput"
                                v-model="search.query"
                                placeholder="Search"
                                solo
                                hide-details
                                flat
                                dense
                                class="search-input"
                                clearable
                                color="teal darken-1"
                                @click:clear="search.value = null"
                                @keydown.enter="search.value = search.query"
                            />
                        </transition>
                    </div>
                    <v-btn
                        style="text-transform: none; margin-right: 10px;"
                        small
                        color="success"
                        @click="addMemberFunc"
                    >
                        <v-icon small>
                            {{ mdiPlus }}
                        </v-icon>&nbsp;Add
                    </v-btn>
                    <v-btn
                        style="text-transform: none;"
                        small
                        color="error"
                        @click="closeDialogFunc"
                    >
                        <v-icon small>
                            {{ mdiClose }}
                        </v-icon>&nbsp;Close
                    </v-btn>
                </v-card-title>
            </template>
            <template #item="{ item, index }">
                <tr
                    @mouseenter="hoveredRow = index"
                    @mouseleave="hoveredRow = null"
                >
                    <td
                        v-for="header in headers"
                        :key="header.value"
                        :style="{ backgroundColor: hoveredRow === index ? '#EEE' : 'white', textAlign: ['MEMB_N', 'ACTION'].includes(header.value) ? 'center' : '' }"
                    >
                        <span style="text-wrap: nowrap;">
                            <template v-if="header.value === 'ACTION'">
                                <v-tooltip top>
                                    <template #activator="{ on }">
                                        <v-btn
                                            small
                                            color="error"
                                            class="white--text"
                                            style="min-width: 0; width: 10px; padding: 17px 21px; margin-right: 10px;"
                                            v-on="on"
                                            @click="handleRemoveMemb(item)"
                                        ><v-icon>{{ mdiTrashCan }}</v-icon></v-btn>
                                    </template>
                                    <span>Remove</span>
                                </v-tooltip>
                            </template>
                            <template v-else>
                                {{ item[header.value] }}
                            </template>
                        </span>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-dialog>
</template>

<script>
import {
    mdiMagnify,
    mdiTrashCan,
    mdiPlus,
    mdiClose
} from '@mdi/js'
export default {
    props: ['show', 'selected'],
    data: () => ({
        mdiMagnify,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        hoveredRow: null,
        hovered: false,
        search: {
            query: null,
            value: null
        },
        headers: [
            { text: 'Member Number', value: 'MEMB_N', align: 'center' },
            { text: 'Name', value: 'LAST_M' },
            { text: 'Action', value: 'ACTION', align: 'center' }
        ]
    }),
    computed: {
        selectedSortByName() {
            return [...this.selected].sort((a, b) => a.LAST_M.localeCompare(b.LAST_M))
        },
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.resetSearch()
                this.$emit('closeDialog')
                this.$emit('temporaryDueAdd', false)
            }
        }
    },
    watch: {
        'search.query'(newVal) {
            if (newVal === '') {
                this.search.value = null
            }
        },
        hovered(val) {
            if (val) {
                this.$nextTick(() => this.$refs.searchInput && this.$refs.searchInput.focus())
            }
        }
    },
    mounted() {
        // Add click outside listener
        document.addEventListener('click', this.handleClickOutside)
    },
    beforeDestroy() {
        // Clean up event listener
        document.removeEventListener('click', this.handleClickOutside)
    },
    methods: {
        onPaginationChange() {
            this.scrollToTop()
        },
        scrollToTop() {
            this.$nextTick(() => {
                if (this.$refs && this.$refs.dataTabletest && this.$refs.dataTabletest.$el) {
                    const tableElement = this.$refs.dataTabletest.$el
                    // Try to find the actual table header row
                    const headerRow = tableElement.querySelector('thead tr') ||
                        tableElement.querySelector('.v-data-table-header tr') ||
                        tableElement.querySelector('tr')

                    if (headerRow) {
                        headerRow.scrollIntoView({
                            // behavior: 'smooth',
                            block: 'start'
                        })
                    } else {
                        // Fallback to table element
                        tableElement.scrollIntoView({
                            // behavior: 'smooth',
                            block: 'start'
                        })
                    }
                }
            })
        },
        resetSearch() {
            this.search = {
                value: null,
                query: null
            }
        },
        toggleSearch() {
            this.isExpanded = !this.isExpanded
            this.$nextTick(() => {
                if (this.isExpanded) {
                    this.$refs.searchInput.focus()
                }
            })
        },
        collapseOnBlur() {
            // Optional: collapse when input loses focus
            this.isExpanded = false
        },
        handleRemoveMemb(item) {
            const index = this.selected.findIndex(obj => obj.MEMB_N === item.MEMB_N)
            this.selected.splice(index, 1)
        },
        closeDialogFunc() {
            this.showDialog = false
        },
        addMemberFunc() {
            this.$emit('addSelection')
            this.$emit('temporaryDueAdd', true)
        }
    }
}
</script>

<style>
.search-wrapper {
    display: flex;
    align-items: center;
    position: relative;
}
.search-icon {
    margin: 9px;
    cursor: pointer;
    color: #555;
    font-size: 24px;
}
/* Transition animation */
.expand-enter-active, .expand-leave-active {
    transition: max-width 0.6s ease, opacity 0.6s ease;
}
.expand-enter, .expand-leave-to {
    max-width: 0;
    opacity: 0;
    overflow: hidden;
}
/* Styling the input */
.search-input {
    max-width: 100%;
    margin-left: 8px;
}
.memberQualificationSelectedTbl > div > table > thead > tr > th {
    width: 100px; /* You can adjust this width as needed */
    position: sticky !important;
    z-index: 2; /* Ensure the second column has a lower z-index than the first one */
    background: white;
    top: 0;
}
.memberQualificationSelectedTbl .v-data-table__wrapper {
    max-height: 70vh; /* Adjust the height according to your needs */
    overflow-y: auto; /* Enable vertical scrolling */
}
</style>
